import { render, staticRenderFns } from "./HostCard.vue?vue&type=template&id=0d55cfd8"
import script from "./HostCard.vue?vue&type=script&lang=js"
export * from "./HostCard.vue?vue&type=script&lang=js"
import style0 from "./HostCard.vue?vue&type=style&index=0&id=0d55cfd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports